const space = {
  atto: "2px",
  femto: "4px",
  pico: "8px",
  nano: "10px",
  micro: "12px",
  milli: "14px",
  centi: "16px",
  deci: "18px",
  deka: "20px",
  hecto: "22px",
  kilo: "24px",
  xxxsmall: "28px",
  xxsmall: "32px",
  xsmall: "36px",
  small: "40px",
  medium: "44px",
  large: "48px",
  xlarge: "56px",
  xxlarge: "64px",
  xxxlarge: "72px",
  xxxxlarge: "100px",
};

export default space;
